import { useEffect, useRef, useCallback } from "react";
import { useMap } from "@vis.gl/react-google-maps";
import { createPortal } from "react-dom";
import { mapChromeShell } from "../../../../styles/mapChromeShell";

// Reactコンポーネントとしてのレイヤートグルコントロール
function LayerToggleControlComponent({ show, onToggle, kmlTitle = "KMLファイル" }) {
    const handleClick = useCallback(() => {
        onToggle(prev => !prev);
    }, [onToggle]);

    return (
        <div
            className={`${mapChromeShell.layerToggle} ${show ? mapChromeShell.layerToggleActive : ""}`}
            onClick={handleClick}
        >
            <span
                className={`${mapChromeShell.layerToggleIcon} ${show ? mapChromeShell.layerToggleIconActive : ""}`}
            >
                {show ? "toggle_on" : "toggle_off"}
            </span>
            <span className={mapChromeShell.layerToggleLabel}>{kmlTitle}</span>
        </div>
    );
}

function MapLayerToggleControl({ show, toggle, kmlTitle }) {
    const map = useMap();
    const controlRef = useRef(null);
    const isInitialized = useRef(false);

    // Google Mapsのコントロールコンテナを作成
    useEffect(() => {
        if (!map || !window.google || isInitialized.current) return;

        const controlDiv = document.createElement("div");
        controlDiv.className = mapChromeShell.layerToggleContainer;
        controlRef.current = controlDiv;

        // 地図にコントロールを追加
        map.controls[window.google.maps.ControlPosition.TOP_RIGHT].push(controlDiv);
        isInitialized.current = true;

        return () => {
            const index = map.controls[window.google.maps.ControlPosition.TOP_RIGHT].getArray().indexOf(controlDiv);
            if (index > -1) {
                map.controls[window.google.maps.ControlPosition.TOP_RIGHT].removeAt(index);
            }
            isInitialized.current = false;
        };
    }, [map]);

    // Portalを使用してReactコンポーネントをGoogle Mapsのコントロール位置にレンダリング
    if (!controlRef.current) {
        return null;
    }

    return createPortal(
        <LayerToggleControlComponent
            show={show}
            onToggle={toggle}
            kmlTitle={kmlTitle}
        />,
        controlRef.current
    );
}

export default MapLayerToggleControl;
